export function parseAutosuggestHighlight(
  text: string,
  matches: { length: number; offset: number }[],
) {
  if (matches.length === 0) {
    return [
      {
        text,
        highlight: false,
      },
    ]
  }

  const sortedMatches = [...matches].sort((lfs, rhs) => lfs.offset - rhs.offset)

  const computedData = sortedMatches.reduce<{
    previousEndIndex: number
    result: { text: string; highlight: boolean }[]
  }>(
    (previousValue, currentValue) => {
      const { previousEndIndex, result } = previousValue
      const { length, offset } = currentValue

      const startIndex = offset
      const endIndex = offset + length

      if (previousEndIndex < startIndex) {
        result.push({
          text: text.slice(previousEndIndex, startIndex),
          highlight: false,
        })
      }

      result.push({
        text: text.slice(startIndex, endIndex),
        highlight: true,
      })

      return {
        previousEndIndex: endIndex,
        result,
      }
    },
    {
      previousEndIndex: 0,
      result: [],
    },
  )

  const { previousEndIndex: finalPreviousIndex, result: finalResult } =
    computedData

  if (finalPreviousIndex < text.length) {
    finalResult.push({
      text: text.slice(finalPreviousIndex, text.length),
      highlight: false,
    })
  }

  return finalResult
}
